module.exports = __webpack_public_path__ + "img/img6.ba27d479.png";